import React, { useContext, useState, useEffect } from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { ThemeContext } from 'styled-components'

const useStyles = makeStyles(props => ({
  root: {
    width: (props.width || 300),
    // width: (props.width || 300) + theme.spacing(3) * 2,
  },
  margin: {
    // height: theme.spacing(3),
  },
}));
const StyledSlider = withStyles({
  root: {
    // color: `${theme.primary}`,
    height: 3,
    padding: '13px 0',
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    marginTop: -12,
    marginLeft: -13,
    boxShadow: '#ebebeb 0px 2px 2px',
    '&:focus,&:hover,&$active': {
      boxShadow: '#ccc 0px 2px 3px 1px',
    },
    '& .bar': {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 3,
  },
  rail: {
    color: '#d8d8d8',
    opacity: 1,
    height: 3,
  },
})(Slider);

function AirbnbThumbComponent(props) {
  return (
    <span {...props}>
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
    </span>
  );
}
export default function CustomSlider(props) {
  const theme = useContext(ThemeContext)
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <StyledSlider
        value={props.sliderValue}
        onChange={(e, v) => {
          props.onChangeHandler(v)
        }}
        ThumbComponent={AirbnbThumbComponent}
        getAriaLabel={index => (index === 0 ? 'Minimum price' : 'Maximum price')}
        {...props}
      />
    </div>
  );
}